import React, { useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import HeaderDetails from '../shared-components/HeaderDetails'
import Card from '../ui-elements/Card'
import Button from '../formfields/Button'
import RedAlert from '../ui-elements/RedAlert'
import CloudformationOutputs from '../CloudformationOutputs.json'


function ExternalUserWelcome() {

    const { tableData, t, externalUserState, currentOrganisation } = useContext(GlobalContext)
    const thisChecklistId = externalUserState && externalUserState.checklistId ? externalUserState.checklistId : null
    const thisChecklist = thisChecklistId && tableData && tableData.Checklists ? tableData.Checklists[thisChecklistId] : null
    const checklistName = thisChecklist ? thisChecklist.ChecklistName : ''
    const checklistPeriodId = externalUserState && externalUserState.checklistPeriodId ? externalUserState.checklistPeriodId : null
    const externalVisitorSettings = thisChecklist && thisChecklist.externalVisitorSettings  
    const companyLogoUrl = externalVisitorSettings && externalVisitorSettings.companyLogo ? `https://${CloudformationOutputs.ImageBucketName}.s3.eu-west-1.amazonaws.com/${currentOrganisation}/${externalVisitorSettings.companyLogo}` : null
 

    if (!thisChecklist || !checklistPeriodId) {
        return <RedAlert>{t('Dashboard.ExternalUserDashboard.checklistOrPeriodNotFound')}</RedAlert>
    }

    return <Card fullwidth={true}>
        <div className={`w-full flex flex-col gap-6 items-center justify-center`}>

            <div className={`w-full flex flex-col gap-2 items-center justify-center`}>


                {(!externalVisitorSettings || !externalVisitorSettings.welcomeHeading) && <p className={``}>
                    {t('Dashboard.ExternalUserWelcome.aboutToStart')}
                </p>}
                {(!externalVisitorSettings || !externalVisitorSettings.welcomeHeading) && <h2 className={`font-righteous text-brandblue text-2xl text-center`}>
                    {checklistName}
                </h2>}
         
                {companyLogoUrl && 
                <img src={companyLogoUrl} alt="Company Logo" className="max-w-64 max-h-64 pb-4" />}

                {externalVisitorSettings && externalVisitorSettings.welcomeHeading && 
                <h2 className={`font-righteous text-brandblue text-2xl text-center`}>{externalVisitorSettings.welcomeHeading}</h2>}

                {externalVisitorSettings && externalVisitorSettings.welcomeText && 
                <p className={``}>{externalVisitorSettings.welcomeText}</p>}
            </div>


            <Button
                internalLinkUrl={`/checklists/${checklistPeriodId}`}
                text={t('Dashboard.ChecklistSummary.startChecklist')}
                variant='primary'
                size={`big`}
                fullwidth={true}
            />
        </div>
    </Card>
}

export default ExternalUserWelcome
